/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Wizard_Loading_Creating_DescriptionInputs */



/**
* | output |
* | --- |
* | "Setting up your new space. Please wait." |
*
* @param {Spaces_Wizard_Loading_Creating_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_wizard_loading_creating_description = /** @type {((inputs?: Spaces_Wizard_Loading_Creating_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Wizard_Loading_Creating_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dein neuer Space wird eingerichtet. Bitte warten.")
	return /** @type {LocalizedString} */ ("Setting up your new space. Please wait.")
});